import React, { useContext, useEffect, useState } from "react";
import { MdSave } from "react-icons/md";
import { findOne, save } from "../../../../services/Salarie__Service";
import { verifyPassword } from "../../../../services/config";
import { updatePassword } from "../../../../services/Settings__Service";
import navContext from "../../../Context/navContext";
import notifyContext from "../../../Context/notifyContext";
import Loader from "../../../Loader/Loader";
import PhoneNumber from "../../../PhoneNumber/PhoneNumber";

const Profil = ({ salarieId = 0 }) => {
  const [errorPassword, setErrorPassword] = useState("");
  const [errorPasswordSecurity, setErrorPasswordSecurity] = useState("");

  const notify = useContext(notifyContext);
  const [error, setError] = useState("");
  const [isSend, setIsSend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [salarie, setSalarie] = useState({
    id: 0,
    matricule: "",
    nom: "",
    prenom: "",
    sexe: 1,
    date_naissance: "",
    fonction: "",
    anciennete: "",
    photo: "",
    email1: "",
    email2: "",
    tel1: "",
    tel2: "",
    pays: 0,
    ville: "",
    adresse: "",
    statut: 1,
    employeur: 0,
    password: "",
    confirmpassword: "",
  });
  const nav = useContext(navContext);

  const [id, setId] = useState(salarieId !== 0 ? salarieId : 0);

  useEffect(() => {
    nav({
      links: [
        {
          href: "/salarie/profil",
          linkname: "Profil",
        },
      ],
      children: "",
    });

    if (id !== undefined && id > 0) {
      setIsLoading(true);
      fetchOneSalarie(id);
    }
  }, []);

  const fetchOneSalarie = async (idParams) => {
    findOne(idParams)
      .then((response) => {
        setSalarie((value) => {
          return {
            ...value,
            ...response.data,
            employeur: response.data.client.nom,
            password: "",
            confirmpassword: "",
          };
        });
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let display_errors = [];

    if (salarie.nom === "") {
      display_errors.push({
        message: "Veuillez entrer le nom",
        id_input: "nom",
      });
    }
    if (salarie.email1 === "") {
      display_errors.push({
        message: "Veuillez entrer l'email 1",
        id_input: "email1",
      });
    }

    if (salarie.tel1 === "") {
      display_errors.push({
        message: "Veuillez entrer le téléphone 1",
        id_input: "tel1",
      });
    }

    display_errors.map(({ message, id_input }, key) => {
      return (
        <label key={key} htmlFor={id_input}>
          {message}
        </label>
      );
    });

    setError(
      display_errors.map(({ message, id_input }, key) => {
        return (
          <label key={key} htmlFor={id_input}>
            {message}
          </label>
        );
      })
    );

    if (display_errors.length === 0) {
      setIsSend(true);
      save(salarie)
        .then(() => {
          setIsSend(false);
          notify("Enregistré avec succès", "success");
        })
        .catch((error) => {
          setIsSend(false);
          if (error.response.data.message !== undefined) {
            notify(error.response.data.message, "error");
          } else {
            notify("Problème au niveau du serveur", "error");
          }
        });
    }
  };

  const handleChange = (e) => {
    setSalarie((elt) => {
      return {
        ...elt,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleSubmitPassword = (e) => {
    e.preventDefault();

    let display_errors = [];
    let display_errors_security = [];

    if (salarie.password === "") {
      display_errors.push({
        message: "Veuillez entrer le mot de passe",
        id_input: "password",
      });
    } else {
      display_errors_security = verifyPassword(salarie.password);
      setErrorPasswordSecurity(
        display_errors_security.map((message, key) => {
          return <p key={key}>{message}</p>;
        })
      );
    }

    if (salarie.confirmpassword === "") {
      display_errors.push({
        message: "Veuillez entrer la confirmation du mot de passe",
        id_input: "confirmpassword",
      });
    } else if (salarie.confirmpassword !== salarie.password) {
      display_errors.push({
        message: "Les mots de passe ne sont pas identiques",
        id_input: "confirmpassword",
      });
    }

    display_errors.map(({ message, id_input }, key) => {
      return <label htmlFor={id_input}>{message}</label>;
    });

    setErrorPassword(
      display_errors.map(({ message, id_input }, key) => {
        return (
          <label key={key} htmlFor={id_input}>
            {message}
          </label>
        );
      })
    );

    if (display_errors.length === 0 && display_errors_security.length === 0) {
      setIsSend(true);
      updatePassword(salarie.password)
        .then(() => {
          setIsSend(false);
          setSalarie((value) => {
            return {
              ...value,
              password: "",
              confirmpassword: "",
            };
          });
          notify("Modifié avec succès", "success");
        })
        .catch((error) => {
          setIsSend(false);
          if (error.response.data.message !== undefined) {
            notify(error.response.data.message, "error");
          } else {
            notify("Problème au niveau du serveur", "error");
          }
        });
    }
  };
  useEffect(() => {
    if (error) {
      document.querySelectorAll("form .error")[0].scrollIntoView();
    }
  }, [error]);
  useEffect(() => {
    if (errorPassword) {
      document.querySelectorAll("form .error")[1].scrollIntoView();
    }
  }, [errorPassword]);
  return (
    <div className="profil">
      <form className="form" onSubmit={handleSubmit}>
        <div className="form-header">
          <small>
            Les champs comportant <span className="required">*</span> sont
            obligatoires
          </small>
          <div className="error">{error}</div>
        </div>

        <div className="form-body">
          <div className="form-group">
            <label htmlFor="nom" className="form-label">
              Matricule <span className="required">*</span> :
            </label>
            <p>{salarie.matricule}</p>
          </div>
          <div className="form-group">
            <label htmlFor="nom" className="form-label">
              Nom (s) <span className="required">*</span> :
            </label>
            <input
              type="text"
              name="nom"
              id="nom"
              className="form-input"
              value={salarie.nom}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="prenom" className="form-label">
              Prénom (s) :
            </label>
            <input
              type="text"
              name="prenom"
              id="prenom"
              className="form-input"
              value={salarie.prenom}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email1" className="form-label">
              Email 1 <span className="required">*</span> :
            </label>
            <input
              type="email"
              name="email1"
              id="email1"
              className="form-input"
              value={salarie.email1}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email2" className="form-label">
              Email 2 :
            </label>
            <input
              type="email"
              name="email2"
              id="email2"
              className="form-input"
              value={salarie.email2}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="tel1" className="form-label">
              Téléphone 1 <span className="required">*</span> :
            </label>
            <PhoneNumber
              name="tel1"
              id="tel1"
              state={salarie.tel1}
              setState={setSalarie}
            />
          </div>

          <div className="form-group">
            <label htmlFor="tel2" className="form-label">
              Téléphone 2 :
            </label>
            <PhoneNumber
              name="tel2"
              id="tel2"
              state={salarie.tel2}
              setState={setSalarie}
            />
          </div>

          <div className="form-group">
            <label htmlFor="">Sexe : </label>
            <div
              style={{
                display: "grid",
                alignItems: "center",
                gridTemplateColumns: "auto auto",
                columnGap: "10px",
              }}
            >
              <label
                htmlFor="masculin"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className="form-label"
              >
                <input
                  type="radio"
                  name="sexe"
                  id="masculin"
                  className="form-input"
                  value="1"
                  onChange={handleChange}
                  checked={parseInt(salarie.sexe) === 1}
                  // defaultChecked={salarie.sexe}
                />
                Masculin
              </label>
              <label
                htmlFor="feminin"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className="form-label"
              >
                <input
                  type="radio"
                  name="sexe"
                  id="feminin"
                  className="form-input"
                  value="0"
                  onChange={handleChange}
                  checked={parseInt(salarie.sexe) === 0}
                />
                Féminin
              </label>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="date_naissance" className="form-label">
              Date de naissance :
            </label>
            <input
              type="date"
              name="date_naissance"
              id="date_naissance"
              className="form-input"
              value={salarie.date_naissance}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="pays" className="form-label">
              Pays :
            </label>
            <select
              name="pays"
              id="pays"
              className="form-select"
              value={salarie.pays}
              onChange={handleChange}
            >
              <option value="0" disabled>
                Sélectionner un pays
              </option>
              <option value="1">Cameroun</option>
              <option value="2">Gabon</option>
              <option value="3">Congo</option>
              <option value="4">Tchad</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="ville" className="form-label">
              Ville :
            </label>
            <input
              type="text"
              name="ville"
              id="ville"
              className="form-input"
              value={salarie.ville}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="adresse" className="form-label">
              Adresse :
            </label>
            <textarea
              name="adresse"
              id="adresse"
              cols="50"
              rows="100"
              className="form-text-area"
              value={salarie.adresse}
              onChange={handleChange}
              wrap="true"
            ></textarea>
          </div>
        </div>

        <div className="form-footer">
          <button type="submit" className="btn">
            <MdSave />
            Enregistrer
          </button>
        </div>
      </form>

      <form className="form" onSubmit={handleSubmitPassword}>
        <div className="form-header">
          <h3>Changer le mot de passe</h3>
          <div className="error">{errorPassword}</div>
        </div>

        <div className="form-body">
          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Mot de passe <span className="required">*</span> :
            </label>
            <input
              type="password"
              name="password"
              id="password"
              className="form-input"
              value={salarie.password}
              onChange={handleChange}
            />
            <div className="error">{errorPasswordSecurity}</div>
          </div>
          <div className="form-group">
            <label htmlFor="confirmpassword" className="form-label">
              Confirmer le mot de passe <span className="required">*</span> :
            </label>
            <input
              type="password"
              name="confirmpassword"
              id="confirmpassword"
              className="form-input"
              value={salarie.confirmpassword}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="form-footer">
          <button type="submit" className="btn">
            <MdSave />
            Enregistrer
          </button>
        </div>
      </form>
      {isSend && <Loader loadingMsg="En cours d'envoi" />}
      {isLoading && <Loader loadingMsg="Chargement" />}
    </div>
  );
};

export default Profil;
